import { ColourSwatch } from 'components/ColourSwatch/ColourSwatch';
import { deleteColour } from 'apiCalls/apiCalls';
import { Box, IconButton } from '@mui/material';
import { ErrorMessage, Loading } from 'components/CommonComponents';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import { PAD_LARGE } from 'providers/designSystem';
import { useColours } from 'hooks/useColours';

const ColourSwatchWithDeleteIcon = ({ colour, colours, setColours }) => {
    const handleDelete = () => {
        deleteColour(colour.id);
        const updatedColours = colours.filter(x => colour !== x);
        setColours({ loading: false, result: updatedColours });
    };
    return (
        <Box position="relative">
            <ColourSwatch testId={`colour-swatch-${colour.id}`} id={colour.id} colour={colour} size={'med'} onClick={() => null} />
            <Box position="absolute" top="-21px" left="27px">
                <IconButton onClick={handleDelete}>
                    <RemoveCircleRoundedIcon color="secondary" />
                </IconButton>
            </Box>
        </Box>
    );
};

const ColourSwatches = ({ colours, setColours }) => {
    return (
        <Box display="flex" flexDirection="row" flexWrap="wrap" gap={PAD_LARGE} paddingTop={PAD_LARGE}>
            {colours.map((colour, index) => {
                return (
                    <ColourSwatchWithDeleteIcon key={index} colour={colour} colours={colours} setColours={setColours} />
                );
            })}
        </Box>
    );
};

export const DeleteColoursComponent = () => {
    const [colours, setColours] = useColours();

    return (
        <>
            {colours?.loading && <Loading />}
            {colours?.error && <ErrorMessage message="Something went wrong" />}
            {colours?.result && <ColourSwatches colours={colours.result} setColours={setColours} />}
        </>
    );
};
